/**
    This file holds all the constants used by native js(typescript) code
*/
import { MainNavigation } from '../modules/navigation/main-nav';
import { SiteSearch } from './navigation/site-search';
export const MAIN_NAV = new MainNavigation();
export const SITE_SEARCH = new SiteSearch();